define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'vueRouter',
    'furniture-list-new2024/component/page-content',


    'css!furniture-list-new2024/furniture-list-new2024.css'
], function(
    Vue,
    i18n,
    PageMixin,
    VueRouter,
    PageContent
){
    Vue.use(VueRouter);

    var routes = [
        { path: '*', component: PageContent }
    ];
    var router = new VueRouter({
        routes: routes,
        mode: 'history',
        base: '/'
    });

    var app = new Vue({
        mixins: [PageMixin],
        router: router,
        i18n: i18n
    });
    app.$mount('#app');
});



//////////////////
// WEBPACK FOOTER
// ./furniture-list-new2024/main.js
// module id = 181
// module chunks = 4